export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65')
];

export const server_loads = [];

export const dictionary = {
		"/": [6],
		"/(auth)/account/credits": [7,[2,3]],
		"/(auth)/account/membership": [8,[2,3]],
		"/company": [20],
		"/company/about": [21],
		"/company/onboard/bonus": [22],
		"/contact": [23],
		"/docs": [24,[5]],
		"/docs/api-reference/authentication": [25,[5]],
		"/docs/api-reference/endpoints": [26,[5]],
		"/docs/getting-started/installation": [27,[5]],
		"/docs/getting-started/quick-start": [28,[5]],
		"/docs/pi-dash": [29,[5]],
		"/docs/pi-dash/agent-orchestration": [30,[5]],
		"/docs/pi-dash/architecture-overview": [31,[5]],
		"/docs/pi-dash/authentication": [32,[5]],
		"/docs/pi-dash/backend-architecture": [33,[5]],
		"/docs/pi-dash/cli-reference": [34,[5]],
		"/docs/pi-dash/cloud-quickstart": [35,[5]],
		"/docs/pi-dash/cloud-runner-protocol": [36,[5]],
		"/docs/pi-dash/deployment": [37,[5]],
		"/docs/pi-dash/development-workflow": [38,[5]],
		"/docs/pi-dash/frontend-architecture": [39,[5]],
		"/docs/pi-dash/getting-started": [40,[5]],
		"/docs/pi-dash/glossary": [41,[5]],
		"/docs/pi-dash/realtime-collaboration": [42,[5]],
		"/docs/pi-dash/releasing": [43,[5]],
		"/docs/pi-dash/repository-layout": [44,[5]],
		"/docs/pi-dash/runner-architecture": [45,[5]],
		"/docs/pi-dash/testing": [46,[5]],
		"/download": [47],
		"/identity-link/confirm": [48],
		"/invite/accept": [49],
		"/login": [50],
		"/login/callback": [51],
		"/login/result": [52],
		"/mcp": [53],
		"/mcp/[key]": [54],
		"/partners": [55],
		"/(auth)/payment/confirm": [9,[2]],
		"/(auth)/payment/failed": [10,[2]],
		"/(auth)/payment/success": [11,[2]],
		"/pricing": [56],
		"/privacy": [~57],
		"/products/ai-helper": [58],
		"/products/ai-search": [59],
		"/products/browserx": [60],
		"/products/data-analytics": [61],
		"/products/pidash": [63],
		"/products/pi": [62],
		"/products/workx": [64],
		"/terms": [~65],
		"/(auth)/user-center": [12,[2,4]],
		"/(auth)/user-center/api-keys": [13,[2,4]],
		"/(auth)/user-center/info": [14,[2,4]],
		"/(auth)/user-center/llm-credits": [15,[2,4]],
		"/(auth)/user-center/llm-usage": [16,[2,4]],
		"/(auth)/user-center/organizations": [17,[2,4]],
		"/(auth)/user-center/provider-keys": [18,[2,4]],
		"/(auth)/user-center/subscriptions": [19,[2,4]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';